import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { DropdownItem } from 'ui-components';
import { EditIcon } from 'ui-components/dist/EditIcon';
import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import useImpersonateCreator from '~/hooks/useImpersonateCreator';
import { useEditPlatformsStore } from '~/screens/ManagePlatforms/EditPlatformsModal_DEPRECATED';
import { ICreator } from '~/types';

interface Props {
  creator: ICreator;
  isOwnAgencyAdmin: boolean;
}

export const EditPlatformsDropdownItem: React.FC<Props> = ({
  creator,
  isOwnAgencyAdmin,
}) => {
  const { showPlatforms } = useEditPlatformsStore();
  const { setImpersonatedCreator } = useImpersonateCreator();
  const router = useRouter();

  const foamUnverifiedToVerified = useFeatureFlag(
    FEATURE_FLAGS.foamUnverifiedToVerified,
  );

  const onEditPlatformClick = useCallback(
    async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (foamUnverifiedToVerified === 'enabled' && isOwnAgencyAdmin) {
        // Allows admins in same agency as managers to edit talent platforms
        // (not in scope) if we ever want to impersonate as admin in same agency...
        // ...BE should allow impersonation so we could follow the same path as below
        router.push(`/t/${creator?.slug}/platform-connections`);
      } else if (foamUnverifiedToVerified === 'enabled') {
        // Redirect to platform-connections if the FF is enabled, impersonating creator
        await setImpersonatedCreator(
          creator,
          `/t/${creator?.slug}/platform-connections`,
        );
        return;
      } else {
        // Otherwise open Edit Platforms modal (keep compatibility with PR FOAM-7322)
        event.stopPropagation();
        showPlatforms(creator);
      }
    },
    [
      creator,
      showPlatforms,
      foamUnverifiedToVerified,
      setImpersonatedCreator,
      isOwnAgencyAdmin,
      router,
    ],
  );

  return (
    <DropdownItem
      onClick={onEditPlatformClick}
      trackId="foam-talent-menu-edit-platforms"
    >
      <EditIcon boxSize={4} />
      Edit Platforms
    </DropdownItem>
  );
};
